import React, { useState } from 'react';
import styled from 'styled-components';

import Filters from './Filters';
import CollapsableCard from 'components/ui/CollapsableCard';

import { getTranslatedString } from 'helpers/i18n';

const StyledCard = styled(CollapsableCard)``;

const FiltersMobile = ({ filterOptions, onCheckFilter, filterSelected, filtersEmpty }) => {
  const [cardOpen, setCardOpen] = useState(false);

  let totalSelected = filterSelected.reduce((count, row) => count + row.length, 0);

  return (
    <StyledCard
      cardOpen={cardOpen}
      setCardOpen={setCardOpen}
      title={getTranslatedString('landlordPortal.filterAndSelect.titles.filters')}
      subtitle={getTranslatedString('landlordPortal.multiselectAdvanced.selected', {
        count: totalSelected,
      })}
    >
      <Filters
        filterOptions={filterOptions}
        onCheckFilter={onCheckFilter}
        filterSelected={filterSelected}
        filtersEmpty={filtersEmpty}
      />
    </StyledCard>
  );
};

export default FiltersMobile;
